export default {
  methods: {
    getBackground(image) {
      return {
        backgroundImage: `url("${process.env.VUE_APP_STATIC_URL}${image}")`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center'
      }
    },
    getBackgroundSmall(image, prefix = 'small_') {
      return {
        backgroundImage: `url("${process.env.VUE_APP_STATIC_URL}${prefix + image}")`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center'
      }
    },
  },
}
